module Meevo.Plugins.Register {
    export class PrintTrustModalController {
        static $inject = [
	        "printTrustRequest", 
            "$mdDialog"
        ];

        constructor(
			private printTrustRequest,
            private $mdDialog: ng.material.IDialogService) {
        }

	    cancel() {
            this.$mdDialog.hide('cancel');
        }
    }   

    angular.module("meevo.plugins.register")
        .controller("meevo.plugins.register.PrintTrustModalController", PrintTrustModalController);
}